// extracted by mini-css-extract-plugin
export default {"bulkActions":"y2CSZuEFbtFqIueKRihM","bulkAction":"AM9qvlC90XY5FvU9nPL_","selectionLabel":"eNaog3D_hUR88Quk3rbd"};